import React from "react"
// import { Link } from "gatsby"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"
import { withPrefix } from 'gatsby'

function getOrdinalNumber(counter) {
  const suffixes = ["st", "nd", "rd"];
  const lastDigit = counter % 10;
  const suffix = suffixes[lastDigit - 1] || "th";
  return counter + suffix;
}

const ranking = [
  {
    "rank": 1,
    "score": 262,
    "school": "高崎商科大学経理研究所",
    "teamName": "会計プロA"
  },
  {
    "rank": 2,
    "score": 260,
    "school": "岐阜県立岐阜商業高等学校",
    "teamName": "簿記は裏切らない"
  },
  {
    "rank": 3,
    "score": 255,
    "school": "専門学校東京ＣＰＡ会計学院",
    "teamName": "マツバＭＧ５"
  },
  {
    "rank": 4,
    "score": 251,
    "school": "滋賀県立八幡商業高等学校",
    "teamName": "國場の海心撃"
  },
  {
    "rank": 5,
    "score": 250,
    "school": "2校合同チーム（岐阜県立大垣商業高等学校、栃木県立宇都宮商業高等学校）",
    "teamName": "やっぱり、猫が好き。"
  },
  {
    "rank": 5,
    "score": 250,
    "school": "朝日大学会計研究部",
    "teamName": "朝日A"
  },
  {
    "rank": 7,
    "score": 249,
    "school": "大原簿記ビジネス専門学校福岡校",
    "teamName": "大原学園福岡校A"
  },
  {
    "rank": 7,
    "score": 249,
    "school": "奈良県立商業高等学校",
    "teamName": "奈良県商　簿記部B"
  },
  {
    "rank": 9,
    "score": 246,
    "school": "大原簿記法律専門学校難波校",
    "teamName": "Piece Peak"
  },
  {
    "rank": 10,
    "score": 245,
    "school": "奈良県立商業高等学校",
    "teamName": "奈良県商　簿記部A"
  },
  {
    "rank": 11,
    "score": 244,
    "school": "大原簿記情報専門学校札幌校",
    "teamName": "大原学園札幌校A"
  },
  {
    "rank": 12,
    "score": 241,
    "school": "大原簿記情報専門学校大宮校",
    "teamName": "減価償却費"
  },
  {
    "rank": 12,
    "score": 241,
    "school": "大原ビジネス公務員専門学校岡山校",
    "teamName": "OKY13 teamA"
  },
  {
    "rank": 14,
    "score": 240,
    "school": "岐阜県立岐阜商業高等学校",
    "teamName": "県岐商簿記部1年"
  },
  {
    "rank": 14,
    "score": 240,
    "school": "愛知県立岡崎商業高等学校",
    "teamName": "豆乳を投入。"
  },
  {
    "rank": 16,
    "score": 239,
    "school": "大原簿記情報医療専門学校名古屋校",
    "teamName": "お手柔らかに"
  },
  {
    "rank": 17,
    "score": 237,
    "school": "下関商業高等学校",
    "teamName": "下関商業A"
  },
  {
    "rank": 18,
    "score": 235,
    "school": "朝日大学会計研究部",
    "teamName": "朝日B"
  },
  {
    "rank": 19,
    "score": 234,
    "school": "大原簿記情報医療専門学校浜松校",
    "teamName": "どうする？ハルト！"
  },
  {
    "rank": 19,
    "score": 234,
    "school": "大原簿記公務員医療福祉保育専門学校立川校",
    "teamName": "Red Bull'SS１"
  }
];

const high_school_ranking = [
  {
    "rank": "1",
    "score": "260",
    "school": "岐阜県立岐阜商業高等学校",
    "teamName": "簿記は裏切らない"
  },
  {
    "rank": "2",
    "score": "251",
    "school": "滋賀県立八幡商業高等学校",
    "teamName": "國場の海心撃"
  },
  {
    "rank": "3",
    "score": "250",
    "school": "2校合同チーム（岐阜県立大垣商業高等学校、栃木県立宇都宮商業高等学校）",
    "teamName": "やっぱり、猫が好き。"
  },
  {
    "rank": "4",
    "score": "249",
    "school": "奈良県立商業高等学校",
    "teamName": "奈良県商　簿記部B"
  },
  {
    "rank": "5",
    "score": "245",
    "school": "奈良県立商業高等学校",
    "teamName": "奈良県商　簿記部A"
  },
  {
    "rank": "6",
    "score": "240",
    "school": "岐阜県立岐阜商業高等学校",
    "teamName": "県岐商簿記部1年"
  },
  {
    "rank": "6",
    "score": "240",
    "school": "愛知県立岡崎商業高等学校",
    "teamName": "豆乳を投入。"
  },
  {
    "rank": "8",
    "score": "237",
    "school": "下関商業高等学校",
    "teamName": "下関商業A"
  },
  {
    "rank": "9",
    "score": "230",
    "school": "熊本県立熊本商業高等学校",
    "teamName": "チームプケプケ"
  },
  {
    "rank": "9",
    "score": "230",
    "school": "岐阜県立岐阜商業高等学校",
    "teamName": "１簿記女子"
  }
];

const RankingPage_ = () => (
  <Layout>
    <SEO
      title="Ranking2023 | 日本商工会議所「日商簿記-1グランプリ2024」公式サイト"
      description="「日商簿記-1グランプリ2024」2023年ランキングページです。"
    />
    <div className="title"><h1><img src={withPrefix('/images/icon_under_0011.png')} alt="2023年ランキング｜日本商工会議所「日商簿記-1グランプリ2024」公式サイト" /> 2023</h1></div>
    <div className="description" id="js-height">
      <p>調整中</p>
    </div>
  </Layout>
)

const RankingPage2023 = () => (
  <Layout>
    <SEO
      title="Ranking2023 | 日本商工会議所「日商簿記-1グランプリ2024」公式サイト"
      description="「日商簿記-1グランプリ2024」2023年ランキングページです。"
    />
    <div className="title"><h1><img src={withPrefix('/images/icon_under_0011.png')} alt="2023年ランキング｜日本商工会議所「日商簿記-1グランプリ2024」公式サイト" /> 2023</h1></div>
    <h2>総合</h2>
    <div className="description" id="js-height">
      {ranking.map((item, index) => {
        const altText = getOrdinalNumber(item["rank"]);
        const imageSrc = withPrefix(`/images/ranknum_${item["rank"].toString().padStart(4, '0')}.png`);
        return (
          <div className="rankboxwrap">
              <div className="rankbox">
                <div className="ranknum"><img src={imageSrc} alt={altText} /></div>
                <div className="score">{item["score"]}点</div>
                <div className="name"><p>{item["school"]}</p><h3>{item["teamName"]}</h3></div>
              </div>
          </div>
        )
      })}
    </div>
    <div className="wrapBtmLink">
      <a href="http://www.kentei.ne.jp/boki_1_2023" target="_blank" rel="noopener noreferrer">&raquo; 21位以下はこちら</a>
    </div>

    <h2>高校生の部</h2>
    <div className="description" id="js-height">
      {high_school_ranking.map((item, index) => {
        const altText = getOrdinalNumber(item["rank"]);
        const imageSrc = withPrefix(`/images/ranknum_${item["rank"].toString().padStart(4, '0')}.png`);
        return (
          <div className="rankboxwrap">
              <div className="rankbox">
                <div className="ranknum"><img src={imageSrc} alt={altText} /></div>
                <div className="score">{item["score"]}点</div>
                <div className="name"><p>{item["school"]}</p><h3>{item["teamName"]}</h3></div>
              </div>
          </div>
        )
      })}
    </div>
    <div className="pastRank">
      <h2>過去のランキング</h2>
      <ul>
        <li><a href="/boki-1/ranking2022">&raquo; Ranking 2022</a></li>
        <li><a href="/boki-1/ranking2019">&raquo; Ranking 2019</a></li>
        <li><a href="/boki-1/ranking2018">&raquo; Ranking 2018</a></li>
        <li><a href="/boki-1/ranking2017">&raquo; Ranking 2017</a></li>
        <li><a href="/boki-1/ranking2016">&raquo; Ranking 2016</a></li>
      </ul>
    </div>
    <br />
  </Layout>
)

export default RankingPage2023
